import * as React from 'react';
import equal from 'fast-deep-equal/react';
import { useDispatch } from 'react-redux';
import DefaultLayout from '~/Layouts/DefaultLayout';
import { default as commonStyles } from '../assets/styles/common.scss';
import { t } from '~/utils/localization';
import { sortBundles } from '~/utils/sort/settings';
import { PRESETS } from '~/types/category';
import { scrollTop } from '~/utils/scrollTop';
import { RootState, useAppSelector } from '~/Store';
import { appActions } from '~/Store/appSlice';

interface IPresetsLayout {
    categoryName: ICategoryList;
}

const stateSelector = (state: RootState) => {
    return {
        categories: state.app.categories,
        activePreset: state.app.activePreset,
        purchasedLimitedBundles: state.account.purchasedLimitedBundles,
        deniedBundlesByUniqueItems: state.account.deniedBundlesByUniqueItems,
        bundles: state.app.bundles,
        sortedBy: state.app.sortedBy,
        disabledCategories: state.app.disabledCategories,
    };
};

const BUNDLES_PREVIEW_LIMIT = 4;

const PresetsLayouts = ({ categoryName }: IPresetsLayout) => {
    const dispatch = useDispatch();
    const state = useAppSelector(stateSelector, equal);
    const category = state.categories[categoryName];
    const presets = category.filters?.presets || [];
    const activeSort = state.sortedBy?.[categoryName];
    const disableCategories = state.disabledCategories;

    if (disableCategories.includes(categoryName)) {
        return (
            <div className={commonStyles.bigNotice}>
                <div className={commonStyles.bigNoticeText}>{t('Товары в этой категории более недоступны')}</div>
            </div>
        );
    }

    if (!presets?.length) {
        return null;
    }

    const setFilterPreset = (presetName: string) => {
        dispatch(appActions.updateActiveFilterPreset({ preset: presetName }));
    };

    const content = presets.map((preset) => {
        const isAll = preset.type === PRESETS.ALL;
        if (state.activePreset && state.activePreset !== preset.name) {
            return null;
        }

        const limit = state.activePreset || isAll ? null : preset.bundlesPreviewLimit || BUNDLES_PREVIEW_LIMIT;

        const fullBundles =
            preset.bundles?.filter((bundleId) => {
                return !!state.bundles[bundleId] && !state.bundles[bundleId].isPurchased;
            }) || [];

        let bundles = fullBundles;

        if (!preset.bundles || !preset.bundles?.length || !bundles.length) {
            return null;
        }

        if (limit) {
            bundles = [...fullBundles].splice(0, limit);
        }

        if (activeSort?.method) {
            bundles = sortBundles(activeSort.name, activeSort.method, state.bundles, bundles);
        }

        return (
            <DefaultLayout
                key={`preset_${preset.name}`}
                title={preset.title}
                description={preset.description}
                bundles={bundles}
                fullBundles={fullBundles}
                showMoreButtonTitle={t('Полный список')}
                preset={preset}
                isShowMoreButton={true}
                isNotRenderFilter={true}
                isLazy={true}
                onShowMoreButtonClick={() => {
                    scrollTop(0, true);
                    setFilterPreset(preset.name);
                }}
            />
        );
    });

    return <React.Fragment>{content}</React.Fragment>;
};

export default PresetsLayouts;
